import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch } from 'react-redux';
import ViewFilterModal from './ViewFilterModal';
import { textAllCleaner } from '../../helpers/text-cleaner';
import CheckboxWithLabel from '../light-weight/CheckboxWithLabel';

const useStyles = makeStyles((theme) => ({
  root: {
    '& li': {
      '& .message': {
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        [theme.breakpoints.up('lg')]: {
          maxWidth: 203,
        },
      },
    },
  },
}));

const ViewFilterModalDecorated = ({
  open = false,
  onClose,
  updateFilter,
  options = [],
  viewsFilter,
  fieldName,
  title,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const valueRaw = viewsFilter[fieldName] || options.map((item) => item.value);
  const [value, setValue] = useState(valueRaw);
  const [serachTerm, setSearchTerm] = useState('');
  const [filteredOptions, setFilteredOptions] = useState([...options]);

  function onConfirm() {
    if (value.length === options.length) {
      // clear filter
      const newFilters = { ...viewsFilter };

      delete newFilters[fieldName];

      if (updateFilter) {
        dispatch(
          updateFilter({
            views: newFilters,
          })
        );
      }
    } else {
      if (updateFilter) {
        dispatch(
          updateFilter({
            views: {
              ...viewsFilter,
              [fieldName]: value,
            },
          })
        );
      }
    }

    onClose();
  }

  function onClear() {
    // clear filter
    const newFilters = { ...viewsFilter };

    delete newFilters[fieldName];

    if (updateFilter) {
      dispatch(
        updateFilter({
          views: newFilters,
        })
      );
    }

    setValue(options.map((item) => item.value));
    setSearchTerm('');
    setFilteredOptions([...options]);
  }

  function onCheckboxChange(val) {
    let newValue = [...value];

    if (newValue.includes(val)) {
      newValue = newValue.filter((item) => item !== val);
    } else {
      newValue.push(val);
    }

    setValue([...newValue]);
  }

  function onSelectAllCheckboxChange() {
    if (value.length === options.length) {
      setValue([]);
    } else {
      setValue(options.map((item) => item.value));
    }
  }

  const handleOnSearch = () => {
    const termFormatted = textAllCleaner(serachTerm);

    if (!termFormatted) {
      setFilteredOptions([...options]);
      return;
    }

    const newOptions = options.filter((item) =>
      textAllCleaner(item.label).includes(termFormatted)
    );

    setFilteredOptions(newOptions);
  };

  const handleOnSearchInput = (val) => {
    setSearchTerm(val);
  };

  const handleOnSearchClear = () => {
    setSearchTerm('');
    setFilteredOptions([...options]);
  };

  return (
    <ViewFilterModal
      open={open}
      onClose={onClose}
      title={title}
      className={classes.root}
      onConfirm={onConfirm}
      onClear={onClear}
      serachTerm={serachTerm}
      onSearch={handleOnSearch}
      onSearchInput={handleOnSearchInput}
      onSearchClear={handleOnSearchClear}
    >
      <ul>
        <li>
          <CheckboxWithLabel
            onChange={onSelectAllCheckboxChange}
            indeterminate={
              value.length && value.length !== options.length ? true : false
            }
            checked={value.length ? true : false}
          >
            Select All
          </CheckboxWithLabel>
        </li>
        {filteredOptions.map((item, index) => (
          <li key={`${index}-${item.value}`}>
            <CheckboxWithLabel
              onChange={() => onCheckboxChange(item.value)}
              checked={value.includes(item.value) ? true : false}
            >
              {item.label}
            </CheckboxWithLabel>
          </li>
        ))}
      </ul>
    </ViewFilterModal>
  );
};

export default ViewFilterModalDecorated;
